import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-play12",
  "use": "icon-common-play12-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" fill=\"none\" id=\"icon-common-play12\">\n    <path d=\"M2.82031 2.29304V9.08992C2.82031 9.49867 3.21875 9.75835 3.54688 9.56242L9.35703 6.08499C9.6411 5.91507 9.6411 5.46788 9.35703 5.29796L3.54688 1.82054C3.21875 1.6246 2.82031 1.88429 2.82031 2.29304Z\" stroke=\"currentColor\" stroke-width=\"1.00189\" stroke-miterlimit=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol